export const users = [
  { id: "1234", name: "علی رضایی", job: "برنامه‌نویس", email: "ali@email.com" },
  {
    id: "5678",
    name: "مینا محمدی",
    job: "طراح گرافیک",
    email: "mina@email.com",
  },
];
